import React, { useMemo } from 'react';
import PlanButton from './PlanButton';

const AllPlansTable = ({ plans, totalVcpu, totalMemory }) => {
  const filteredPlans = useMemo(() => {
    if (totalVcpu === 0 && totalMemory === 0) {
      return plans;
    }
    return plans.filter(plan => 
      parseFloat(plan.vcpu) >= totalVcpu && parseFloat(plan.memory_gb) >= totalMemory
    );
  }, [plans, totalVcpu, totalMemory]);

  return (
    <div className="plans-table-container">
      <h2>پلن‌های موجود</h2>
      <table className="chakra-table css-zzzyts">
        <thead className="css-0">
          <tr className="css-0">
            <th className="css-1zts0j">نوع پلن</th>
            <th className="css-1zts0j">vCPU</th>
            <th className="css-1zts0j">Memory (GB)</th>
            <th className="css-1zts0j">قیمت</th>
            <th className="css-1zts0j">خرید</th>
          </tr>
        </thead>
        <tbody className="css-tdnrhj">
          {filteredPlans.map(plan => (
            <tr key={plan._ID} className="css-0">
              <td className="css-xumdn4" style={{ textAlign: 'center' }}>
                <div className="chakra-stack css-fqllj7">
                  <p className="chakra-text css-0">{plan.plan_name}</p>
                </div>
              </td>
              <td className="css-xumdn4" style={{ textAlign: 'center' }}>{plan.vcpu}</td>
              <td className="css-xumdn4" style={{ textAlign: 'center' }}>{plan.memory_gb} GB</td>
              <td className="css-xqor98" style={{ textAlign: 'center' }}>{parseInt(plan.price_monthly).toLocaleString()} تومان</td>
              <td className="css-xumdn4" style={{ textAlign: 'center' }}>
                <PlanButton planId={plan._ID} />
              </td>
            </tr>
          ))}
          {filteredPlans.length === 0 && (
            <tr>
              <td colSpan="5" className="css-xumdn4" style={{ textAlign: 'center' }}>هیچ پلن مناسبی یافت نشد.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AllPlansTable;